"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/************************************** THIRD-PARTY MODULES ***************************************/
var localforage_1 = __importDefault(require("localforage"));
var shared_1 = require("mad-utils/lib/shared");
/******************************************** LOGGING *********************************************/
var shared_2 = require("mad-logs/lib/shared");
var log = shared_2.logFactory("temp-localforage-storage.ts", shared_2.Styles.bracelet);
/******************************************** HELPERS *********************************************/
var keySplitPoint = " -> [data_key]::";
var tempTag = "[-TEMP-]";
function isMatchingTempKey(key, namespace) {
    if (namespace === void 0) { namespace = ""; }
    return (key.includes(tempTag) &&
        key.includes(keySplitPoint) &&
        (!namespace || key.includes(namespace)));
}
/**
 * Build temporary localForage tag from function name & key
 */
function buildTempSSTag(key, namespace) {
    return "" + tempTag + (namespace || '') + keySplitPoint + key;
}
/*********************************** TEMPORARY SESSION STORAGE ************************************/
/**
 * Get item with given key under given namespace (default: ``) within the TEMP
 * localForage data
 */
function getItem(key, namespace) {
    if (namespace === void 0) { namespace = ""; }
    return localforage_1.default
        .getItem(buildTempSSTag(key, namespace))
        .catch(function (error) { return log.error("getItem :: failed with error:", error); });
}
exports.getItem = getItem;
/**
 * Get all items in the given namespace (default: _ALL_ items) within the TEMP
 * localForage data
 */
function getAll(namespace) {
    if (namespace === void 0) { namespace = ""; }
    return localforage_1.default
        .keys()
        .then(function (keys) {
        return Promise.all(keys.map(function (key) {
            if (isMatchingTempKey(key, namespace))
                return localforage_1.default.getItem(key);
        }));
    })
        .then(shared_1.rmAllFalsy)
        .catch(function (error) { return log.error("getAll :: failed with error:", error); });
}
exports.getAll = getAll;
/**
 * Set data at given key under given namespace (default: ``) within the TEMP
 * localForage data
 */
function setItem(key, val, namespace) {
    if (namespace === void 0) { namespace = ""; }
    return localforage_1.default
        .setItem(buildTempSSTag(key, namespace), val)
        .catch(function (error) { return log.error("setItem :: failed with error:", error); });
}
exports.setItem = setItem;
/**
 * Remove given key under given namespace (default: ``) within the TEMP
 * localForage data
 */
function removeItem(key, namespace) {
    if (namespace === void 0) { namespace = ""; }
    return localforage_1.default
        .removeItem(buildTempSSTag(key, namespace))
        .catch(function (error) { return log.error("removeItem :: failed with error:", error); });
}
exports.removeItem = removeItem;
/**
 * Remove all keys in the given namespace (default: removes all) within the
 * TEMP localForage data
 */
function clearAll(namespace) {
    if (namespace === void 0) { namespace = ""; }
    return localforage_1.default
        .keys()
        .then(function (keys) {
        return Promise.all(keys.map(function (key) {
            if (isMatchingTempKey(key, namespace)) {
                return localforage_1.default.removeItem(key);
            }
        }));
    })
        .catch(function (error) { return log.error("clearAll :: failed with error:", error); });
}
exports.clearAll = clearAll;
/**
 * Return all values in the given namespace within the TEMP localForage data,
 * then remove all
 */
function getAllAndClear(namespace) {
    if (namespace === void 0) { namespace = ""; }
    var exportData;
    return getAll(namespace)
        .then(function (data) {
        exportData = data;
        return clearAll(namespace);
    })
        .then(function (_data) { return exportData; })
        .catch(function (error) { return log.error("getAllAndClear :: failed with error:", error); });
}
exports.getAllAndClear = getAllAndClear;
//# sourceMappingURL=temp-localforage-storage.js.map